/**
 *
 * key
 *
 */


const key = 'c3BlY2lhbF9pbnN0cnVjdGlvbg=='

export default key